import apiClient from './apiService';

export type TechItemSource = 'APPLICATION' | 'IT_ASSET';

export interface TechItem {
    source: TechItemSource;
    id: number;
    name: string;
    code?: string | null;
}

export const capaTechItemsService = {
    list: async (): Promise<TechItem[]> => {
        const resp = await apiClient.get('/api/v1/cap/tech-items');
        return resp.data?.data ?? [];
    },
};
